import React, { Component } from 'react';
import { API_ROOT } from '../../../baseUrls';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  Box,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Hidden,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const styles = () => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  }
})

class Designees extends Component {
  constructor(props) {
    super(props)
    this.state = {
      designeeMode: 'display',
      designee1: '',
      designee1Focus: false,
      relationship1: '',
      relationship1Focus: false,
      designee2: '',
      designee2Focus: false,
      relationship2: '',
      relationship2Focus: false,
      designee3: '',
      designee3Focus: false,
      relationship3: '',
      relationship3Focus: false,
      doNotDisclose: null,
      showDesigneesSuccessMessage: false,
    }
  }

  updateDesignees() {
    const formData = new FormData()
    formData.append("user[designee1]", this.state.designee1)
    formData.append("user[relationship1]", this.state.relationship1)
    formData.append("user[designee2]", this.state.designee2)
    formData.append("user[relationship2]", this.state.relationship2)
    formData.append("user[designee3]", this.state.designee3)
    formData.append("user[relationship3]", this.state.relationship3)
    formData.append("user[do_not_disclose]", (this.state.doNotDisclose === 'no').toString())
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${ API_ROOT }/users/${ this.props.user.uid }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.setState({ showDesigneesSuccessMessage: true })
      }
      this.setState({ designeeMode: 'display' })
    })
    .catch(error => console.error(error))
  }

  renderDesigneeDisplay() {
    return (
      <Box>
        { this.state.showDesigneesSuccessMessage ? <Box style={{marginBottom: "1rem"}}><Alert onClose={ () => this.setState({ showDesigneesSuccessMessage: false }) }>Designees was updated.</Alert></Box> : '' }
        <Hidden mdUp>
          <Box pb={2}><Typography>Designees</Typography></Box>
        </Hidden>
        <div style={{display:"flex", gap:"0.5rem"}}>
          <Hidden smDown>
            <Box><Typography>Designees</Typography></Box>
          </Hidden>
          <Box display="flex" flexGrow={1} justifyContent="center"><Typography>{ this.props.user.do_not_disclose ? 'No' : 'Yes' }</Typography></Box>
          <Button variant="contained" color="primary" onClick={ () => this.setState({ designeeMode: 'form' }) }>Update</Button>
        </div>
      </Box>
    )
  }

  renderDesigneeForm(classes) {
    return (
      <Box>
        <Typography className={classes.cardTitle} variant="subtitle1" gutterBottom>
          Designees
        </Typography>
        <Typography fontStyle="italic" component="div">
          <Box fontStyle="italic">
            In the event of my legal death or physical/mental incapacitation:
          </Box>
          <Box>
            I agree to and permit the LifeNaut staff to provide access to my LifeNaut account to the following designees:
          </Box>
        </Typography>

        <Box className={ classes.fieldWrapper }>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Relationship</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TextField
                    value={ this.state.designee1Focus ? this.state.designee1 : this.props.user.designee1 }
                    onFocus={ () => {
                      if (this.state.designee1Focus === false) {
                        this.setState({ designee1: this.props.user.designee1 })
                      }
                      this.setState({ designee1Focus: true })
                    } }
                    onChange={ evt => this.setState({ designee1: evt.target.value }) }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={ this.state.relationship1Focus ? this.state.relationship1 : this.props.user.relationship1 }
                    onFocus={ () => {
                      if (this.state.relationship1Focus === false) {
                        this.setState({ relationship1: this.props.user.relationship1 })
                      }
                      this.setState({ relationship1Focus: true })
                    } }
                    onChange={ evt => this.setState({ relationship1: evt.target.value }) }
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <TextField
                    value={ this.state.designee2Focus ? this.state.designee2 : this.props.user.designee2 }
                    onFocus={ () => {
                      if (this.state.designee2Focus === false) {
                        this.setState({ designee2: this.props.user.designee2 })
                      }
                      this.setState({ designee2Focus: true })
                    } }
                    onChange={ evt => this.setState({ designee2: evt.target.value }) }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={ this.state.relationship2Focus ? this.state.relationship2 : this.props.user.relationship2 }
                    onFocus={ () => {
                      if (this.state.relationship2Focus === false) {
                        this.setState({ relationship2: this.props.user.relationship2 })
                      }
                      this.setState({ relationship2Focus: true })
                    } }
                    onChange={ evt => this.setState({ relationship2: evt.target.value }) }
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <TextField
                    value={ this.state.designee3Focus ? this.state.designee3 : this.props.user.designee3 }
                    onFocus={ () => {
                      if (this.state.designee3Focus === false) {
                        this.setState({ designee3: this.props.user.designee3 })
                      }
                      this.setState({ designee3Focus: true })
                    } }
                    onChange={ evt => this.setState({ designee3: evt.target.value }) }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={ this.state.relationship3Focus ? this.state.relationship3 : this.props.user.relationship3 }
                    onFocus={ () => {
                      if (this.state.relationship3Focus === false) {
                        this.setState({ relationship3: this.props.user.relationship3 })
                      }
                      this.setState({ relationship3Focus: true })
                    } }
                    onChange={ evt => this.setState({ relationship3: evt.target.value }) }
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>

        <Typography>
          Disclose the contents of or access to my account to an authorized individual or fiduciary:
        </Typography>
        <Box className={ classes.fieldWrapper }>
          <RadioGroup name="designees" value={ this.state.doNotDisclose || ((this.props.user.do_not_disclose === false) ? 'yes' : 'no') } onChange={ evt => this.setState({ doNotDisclose: evt.target.value }) }>
            <FormControlLabel value='yes' control={<Radio />} label="Yes" />
            <FormControlLabel value='no' control={<Radio />} label="No" />
          </RadioGroup>
        </Box>
        <Typography>
          Printable version of <a href={`${ API_ROOT }/mindfiles/${ this.props.user.uid }/transfer?id=protocol`} target="_blank" rel="noopener noreferrer">LifeNaut Legal Death Protocol</a>
        </Typography>
        <Box className={ classes.buttonWrapper }>
          <Button variant="contained" color="primary" onClick={ this.updateDesignees.bind(this) }>Update</Button>
          <Button style={{ marginLeft: 8 }} variant="contained" color="default" onClick={ () => this.setState({ designeeMode: 'display' }) }>Cancel</Button>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props
    return (this.state.designeeMode === 'display') ? this.renderDesigneeDisplay(classes) : this.renderDesigneeForm(classes)
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Designees))
